// @flow
import { CALL_API } from '../../api';
import * as ActionTypes from './auth.actionTypes';
import schema from '../../api/schema';
import history from '../../modules/core/history';
import {getProducts} from '../../modules/product/product.actions';
import {getCurrentCampaign} from '../../modules/campaign/campaign.actions';
import {getContents} from '../../modules/content/content.actions';

const postAuthToken = token => ({
  [CALL_API]: {
    types: [ActionTypes.LOGIN_REQUEST, ActionTypes.LOGIN_SUCCESS, ActionTypes.LOGIN_FAILURE],
    endpoint: `api/auth/authToken`,
    schema: schema.authResponseSchema,
    requestInit: {
      method: 'POST',
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify({
        authToken: token,
      }),
    },
  },
});

const postAdminLoginAsUser = email => ({
  [CALL_API]: {
    types: [ActionTypes.ADMIN_LOGIN_REQUEST, ActionTypes.ADMIN_LOGIN_SUCCESS, ActionTypes.LOGIN_FAILURE],
    endpoint: `api/auth/adminLogin`,
    schema: schema.authResponseSchema,
    authorization: true,
    requestInit: {
      method: 'POST',
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify({
        email,
      }),
    },
  },
});

const postLoginCredentials = credentials => ({
  [CALL_API]: {
    types: [ActionTypes.LOGIN_REQUEST, ActionTypes.LOGIN_SUCCESS, ActionTypes.LOGIN_FAILURE],
    endpoint: `api/auth/local`,
    schema: schema.authResponseSchema,
    authFailHandling: true,
    requestInit: {
      method: 'POST',
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify({
        email: credentials.username,
        password: credentials.password,
      }),
    },
  },
});

const doLogout = () => ({
  [CALL_API]: {
    types: [ActionTypes.LOGOUT_REQUEST, ActionTypes.LOGOUT_SUCCESS, ActionTypes.LOGOUT_FAILURE],
    endpoint: `api/auth/local/logout`,
    authorization: true,
  },
});

export const loginUserToken = token => (dispatch, getState) => {
  if (!token) {
    localStorage.removeItem('cmore-sisapiiri-token');
    return dispatch({
      type: ActionTypes.AUTH_INVALIDATE,
    });
  }

  return dispatch(postAuthToken(token)).then(response => {
    if (response.type === ActionTypes.LOGIN_SUCCESS) {
      //TODO Centralized token handling
      localStorage.setItem('cmore-sisapiiri-token', response.response.result.token);
    } else {
      //TODO Centralized token handling
      localStorage.removeItem('cmore-sisapiiri-token');
    }
    return Promise.resolve();
  });
};

export const adminLoginAsUser = email => (dispatch, getState) => {
  // window.location.replace('/');
  history.push('/');
  return dispatch(postAdminLoginAsUser(email)).then(response => {
    if (response.type === ActionTypes.ADMIN_LOGIN_SUCCESS) {
      //TODO Centralized token handling
      localStorage.setItem('cmore-sisapiiri-token', response.response.result.token);
    } else {
      //TODO Centralized token handling
      localStorage.removeItem('cmore-sisapiiri-token');
    }
    return Promise.resolve(response);
  })
  .then(async result=>{
    // Fetch rest of the required stuff
    await Promise.all([
      getProducts(true)(dispatch),
      getCurrentCampaign()(dispatch, ()=>{
        return {entities: {campaign: {current: null}}}
      }),
      getContents(0)(dispatch),
    ]);

    return result;
  });
};

export const loginUser = credentials => (dispatch, getState) => {
  return dispatch(postLoginCredentials(credentials)).then(response => {
    if (response.type === ActionTypes.LOGIN_SUCCESS) {
      //TODO Centralized token handling
      localStorage.setItem('cmore-sisapiiri-token', response.response.result.token);
    } else {
      //TODO Centralized token handling
      localStorage.removeItem('cmore-sisapiiri-token');
    }
    return Promise.resolve(response);
  });
};

export const logoutUser = () => (dispatch, getState) => {
  return dispatch(doLogout())
    .then(response => {
      localStorage.removeItem('cmore-sisapiiri-token');
      window.location.replace('/');
    })
    .catch(error => {
      localStorage.removeItem('cmore-sisapiiri-token');
      window.location.replace('/');
    });
};



// WEBPACK FOOTER //
// ./src/modules/auth/auth.actions.js